import type { ICookieProvider } from '@/domains/policy/types/cookie.types'

export interface IProps {
  data: ICookieProvider[];
}

export enum EEXPIRED_TIME {
  ONE_DAY='cookies.table.expiredTime.oneDay',
  SEVEN_DAYS='cookies.table.expiredTime.sevenDays',
  ONE_MINUTE = 'cookies.table.expiredTime.oneMinute',
  TEN_MINUTES= 'cookies.table.expiredTime.tenMinutes',
  FIFTEEN_MINUTES= 'cookies.table.expiredTime.fifteenMinutes',
  ONE_YEAR='cookies.table.expiredTime.oneYear',
  ONE_YEAR_24_DAYS='cookies.table.expiredTime.oneYear24Days',
  THIRTEEN_MONTHS='cookies.table.expiredTime.thirteenMonths',
  SIXTEEN_YEARS='cookies.table.expiredTime.sixteenYears',
  SIXTY_DAYS='cookies.table.expiredTime.sixtyDays',
  NINETY_DAYS='cookies.table.expiredTime.ninetyDays',
  FOUR_HUNDRED_DAYS='cookies.table.expiredTime.fourHundredDays',
  TWO_YEARS='cookies.table.expiredTime.twoYears',
  THREE_YEARS='cookies.table.expiredTime.threeYears',
  TEN_YEARS='cookies.table.expiredTime.tenYears',
  END_OF_SESSION ='cookies.table.expiredTime.endOfSession',
  THIRTY_MINUTES='cookies.table.expiredTime.thirtyMinutes',
  THIRTY_DAYS='cookies.table.expiredTime.thirtyDays',
  YEAR_ON_DAYS='cookies.table.expiredTime.yearOnDays',
  ONE_HUNDRED_MS='cookies.table.expiredTime.oneHundredMS',
  TWENTY_FOUR_HOURS='cookies.table.expiredTime.twentyFourHours',
  ONE_MONTH='cookies.table.expiredTime.oneMonth',
  FIVE_MONTHS ='cookies.table.expiredTime.fiveMonths',
  TWO_MONTHS ='cookies.table.expiredTime.twoMonths',
  THREE_MONTHS='cookies.table.expiredTime.threeMonths',
  FIVE_MONTHS_27_DAYS='cookies.table.expiredTime.fiveMonths27DAYS',
  SIX_MONTHS='cookies.table.expiredTime.sixMonths',
  SEVEN_MONTHS ='cookies.table.expiredTime.sevenMonths',
  EIGHT_MONTHS ='cookies.table.expiredTime.eightMonths',
  NINE_MONTHS ='cookies.table.expiredTime.nineMonths',
  TEN_MONTHS ='cookies.table.expiredTime.tenMonths',
  ELEVEN_MONTHS ='cookies.table.expiredTime.elevenMonths',
}

export enum ECOOKIE_TYPE {
  MARKETING = 'cookies.table.cookieType.marketing',
  NECESSARY = 'cookies.table.cookieType.necessary',
  ANALYTICS = 'cookies.table.cookieType.analytics'
}
